import * as React from "react"
import { Button, ButtonProps } from "./button"
import { cn } from "@/lib/utils"

export interface EnhancedButtonProps extends ButtonProps {
  ripple?: boolean
  bounce?: boolean
  glow?: boolean
  loading?: boolean
}

const EnhancedButton = React.forwardRef<HTMLButtonElement, EnhancedButtonProps>(
  ({ className, ripple = true, bounce = false, glow = false, loading = false, children, ...props }, ref) => {
    const [isClicked, setIsClicked] = React.useState(false)

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (bounce) {
        setIsClicked(true)
        setTimeout(() => setIsClicked(false), 600)
      }
      
      props.onClick?.(e)
    }

    return (
      <Button
        ref={ref}
        className={cn(
          ripple && "touch-feedback",
          bounce && isClicked && "micro-bounce",
          glow && "hover:micro-glow",
          loading && "opacity-75 cursor-wait",
          className
        )}
        onClick={handleClick}
        disabled={loading || props.disabled}
        {...props}
      >
        {loading ? (
          <>
            <div className="loading-spinner mr-2" />
            {children}
          </>
        ) : (
          children
        )}
      </Button>
    )
  }
)

EnhancedButton.displayName = "EnhancedButton"

export { EnhancedButton }